import React from 'react';
import { ArcBatteryLife, ArcBox, ArcStack, ArcText } from '@src/core/ui';
import { ArcDroneProps, ArcDroneVariantProps } from './types';
import { EMPTY_STRING } from '@src/core/config';
import { formatDroneDisplayStatus, getOtaVersionTone } from '@src/core/features';

const ArcDrone: React.FC<ArcDroneProps> & ArcDroneVariantProps = (props) => {
  const { drone, ...rest } = props;
  const otaTone = getOtaVersionTone(drone.ota);

  return (
    <ArcStack
      spacing={1}
      border='1px solid'
      {...rest}
    >
      <ArcStack spacing={2} direction='row' alignItems='center'>
        <ArcStack direction='row' justifyContent='space-between' width='100%'>
          <ArcStack spacing={1}>
            <ArcText.h6 maxLines={1}> {drone.name ?? EMPTY_STRING} </ArcText.h6>
            <ArcText.button color='text.secondary'>
              {formatDroneDisplayStatus(drone) || EMPTY_STRING}
            </ArcText.button>
          </ArcStack>

          <ArcStack spacing={1} alignItems='flex-end'>
            <ArcText.caption fontSize={12} whiteSpace='nowrap'> {drone.serialNumber ?? EMPTY_STRING} </ArcText.caption>
            <ArcStack direction='row' alignItems='center' spacing={1}>
              <ArcBatteryLife percent={drone.batteryHealth} />
            </ArcStack>
          </ArcStack>
        </ArcStack>
        {otaTone && (
          <ArcBox
            width={8}
            height={8}
            borderRadius='50%'
            bgcolor={`${otaTone}.main`}
          />
        )}
      </ArcStack>
    </ArcStack>
  );
};

ArcDrone.primary = ({ selected, ...rest }) => (
  <ArcDrone
    p='12px'
    borderRadius={1}
    bgcolor='background.paper'
    borderColor={selected ? 'brand.main' : 'background.paper'}
    sx={{
      cursor: 'pointer',
      '&:hover': {
        bgcolor: 'grey.800',
      },
    }}
    {...rest}
  />
);

ArcDrone.error = ({ selected, ...rest }) => (
  <ArcDrone
    p='12px'
    borderRadius={1}
    bgcolor='rose.main'
    borderColor={selected ? 'error.main' : 'rose.main'}
    sx={{ cursor: 'pointer' }}
    {...rest}
  />
);

export default ArcDrone;
